const regexSubtitleTimecode = /^([0-5][0-9]):([0-5][0-9]).\d{3}$/;

export default regexSubtitleTimecode;
